import { propertyMeta, typeMeta, MetaTypesBase } from "@/autogen/common";
import { PhoneTypeMeta } from "./PhoneTypeMeta";

export const CreatePhoneMetaFields = {
  phoneNumber: propertyMeta("phoneNumber", false, true, false, MetaTypesBase.string),
  phoneType: propertyMeta("phoneType", false, false, false, PhoneTypeMeta),
};

export const CreatePhoneMeta = typeMeta("CreatePhone", CreatePhoneMetaFields);
